module.exports = __webpack_public_path__ + "media/images/easy-steps-4-bb329085c4bbf0387e4c1d0aac18c22a.jpeg";